import * as React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface UserProps {
    id: number;
    userDetails: UserDetails;
    update(userDetails: UserDetails): void;
    save(): void;
}

interface User {
    companies: GenericList[];
    departments: GenericList[];
    statusOptions: GenericList[];
    emailSignatures: GenericList[];
    errors: any;
    loading: boolean;
}

interface GenericList {
    id: number;
    name: string;
}

interface UserDetails {
    id: number;
    firstName: string;
    lastName: string;
    companyId: number;
    departmentId: number;
    extension: string;
    mobile: string;
    email: string;
    emailSignatureId: number;
    userName: string;
    password: string;
    confirmPassword: string;
    statusId: number;
}

export default class UserDetail extends React.Component<UserProps, User> {
    constructor(props: UserProps) {
        super(props);
        this.state = {
            companies: [],
            departments: [],
            statusOptions: [],
            emailSignatures: [],
            errors: {},
            loading: true
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();

        axios.get('api/User/GetDropdowns', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ companies: res.data.companies, departments: res.data.departments, statusOptions: res.data.statusOptions, emailSignatures: res.data.emailSignatures, loading: false });
        });
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        var userDetails = this.props.userDetails;
        let newUser: any = {};
        newUser = userDetails;
        newUser[e.target.name] = e.target.value;

        this.setState({ errors: errors });
        this.props.update(newUser);
    }

    resetPassword = () => {
        this.resetUserPassword();
    }

    async resetUserPassword() {
        const token = await authService.getAccessToken();

        var details = {
            "username": this.props.userDetails.userName
        };

        axios.post('Account/ForgotPassword', details, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Reset Password Email sent to " + this.props.userDetails.email);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    validate = () => {
        let fields = this.props.userDetails;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.firstName) {
            formIsValid = false;
            errors["firstName"] = "First Name is required";
        }
        if (!fields.lastName) {
            formIsValid = false;
            errors["lastName"] = "Last Name is required";
        }
        if (fields.departmentId < 1) {
            formIsValid = false;
            errors["departmentId"] = "Department is required";
        }
        if (!fields.userName) {
            formIsValid = false;
            errors["userName"] = "Username is required";
        }
        if (!fields.email) {
            formIsValid = false;
            errors["email"] = "Email is required";
        }
        if (this.props.id == 0) {
            //check password - if existing user, separate form to change password
            if (!fields.password) {
                formIsValid = false;
                errors["password"] = "Password is required";
            }
            if (!fields.confirmPassword) {
                formIsValid = false;
                errors["confirmPassword"] = "Confirm Password is required";
            }
            if (fields.password && fields.confirmPassword) {
                //check password and confirm password match
                if (fields.password != fields.confirmPassword) {
                    formIsValid = false;
                    errors["confirmPassword"] = "Password and Confirm Password must match";
                }
            }
        }
        if (fields.statusId < 0) {
            formIsValid = false;
            errors["statusId"] = "Status is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.props.save();
        }

    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderUserDetail();


        return (<div>
            {contents}
        </div>);
    }

    renderUserDetail = () => {
        let companyOptions = this.state.companies;
        let departmentOptions = this.state.departments;
        let statusOptions = this.state.statusOptions;
        let emailSignatures = this.state.emailSignatures;
        let userDetails = this.props.userDetails;

        return (
            <form name="user" onSubmit={this.save}>
                <div>
                    <label className="input-group" htmlFor="email">
                        <span className="label">Email</span>
                        <input className="input" type="text" id="email" name="email" value={userDetails.email} onChange={(e) => this.handleChange(e)} disabled={this.props.id == 0 ? false : true}></input>
                    </label>
                    <span className="label errors">{this.state.errors["email"]}</span>

                    <label className="input-group" htmlFor="userName">
                        <span className="label">Username</span>
                        <input className="input" type="text" id="userName" name="userName" value={userDetails.userName} onChange={(e) => this.handleChange(e)} disabled={this.props.id == 0 ? false : true}></input>
                    </label>
                    <span className="label errors">{this.state.errors["userName"]}</span>

                    <div className={this.props.id == 0 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="password">
                            <span className="label">Password</span>
                            <input className="input" type="password" id="password" name="password" value={userDetails.password} onChange={(e) => this.handleChange(e)}></input>
                        </label>
                        <span className="label errors">{this.state.errors["password"]}</span>
                    </div>
                    <div className={this.props.id == 0 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="confirmPassword">
                            <span className="label">Confirm Password</span>
                            <input className="input" type="password" id="confirmPassword" name="confirmPassword" value={userDetails.confirmPassword} onChange={(e) => this.handleChange(e)}></input>
                        </label>
                        <span className="label errors">{this.state.errors["confirmPassword"]}</span>
                    </div>
                    <div className={this.props.id === 0 ? "hidden" : ""}>
                        <label className="input-group" htmlFor="companyId">
                            <span className="label">Company</span>
                            <select className="select" id="companyId" name="companyId" value={userDetails.companyId} disabled>
                                <option hidden defaultValue="-1"></option>
                                {companyOptions.map(comp =>
                                    <option key={comp.id} value={comp.id}>{comp.name}</option>
                                )};
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["companyId"]}</span>
                    </div>

                    <label className="input-group" htmlFor="departmentId">
                        <span className="label">Department</span>
                        <select className="select" id="departmentId" name="departmentId" value={userDetails.departmentId} onChange={(e) => this.handleChange(e)}>
                            <option hidden defaultValue="-1"></option>
                            {departmentOptions.map(dept =>
                                <option key={dept.id} value={dept.id}>{dept.name}</option>
                            )};
                        </select>
                    </label>
                    <span className="label errors">{this.state.errors["departmentId"]}</span>

                    <label className="input-group" htmlFor="extension">
                        <span className="label">Extension</span>
                        <input className="input" type="text" id="extension" name="extension" value={userDetails.extension} onChange={(e) => this.handleChange(e)}></input>
                    </label>

                    <label className="input-group" htmlFor="firstName">
                        <span className="label">First Name</span>
                        <input className="input" type="text" id="firstName" name="firstName" value={userDetails.firstName} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <span className="label errors">{this.state.errors["firstName"]}</span>

                    <label className="input-group" htmlFor="lastName">
                        <span className="label">Last Name</span>
                        <input className="input" type="text" id="lastName" name="lastName" value={userDetails.lastName} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <span className="label errors">{this.state.errors["lastName"]}</span>

                    <label className="input-group" htmlFor="mobile">
                        <span className="label">Mobile</span>
                        <input className="input" type="text" id="mobile" name="mobile" value={userDetails.mobile} onChange={(e) => this.handleChange(e)}></input>
                    </label>

                    <label className="input-group" htmlFor="emailSignatureId">
                        <span className="label">Email Signature</span>
                        <select className="select" id="emailSignatureId" name="emailSignatureId" value={userDetails.emailSignatureId} onChange={(e) => this.handleChange(e)}>
                            <option hidden defaultValue="-1"></option>
                            {emailSignatures.map(sign =>
                                <option key={sign.id} value={sign.id}>{sign.name}</option>
                            )};
                        </select>
                    </label>

                    <label className="input-group" htmlFor="statusId">
                        <span className="label">Status</span>
                        <select className="select" id="statusId" name="statusId" value={userDetails.statusId} onChange={(e) => this.handleChange(e)} disabled={userDetails.id == 0 ? true : false}>
                            {statusOptions.map(status =>
                                <option key={status.id} value={status.id}>{status.name}</option>
                            )};
                        </select>
                    </label>
                    <span className="label errors">{this.state.errors["statusId"]}</span>

                    <button className="defaultbutton-prev" type="submit">Save</button>
                    <button className={this.props.userDetails.id === 0 ? "hidden" : "defaultbutton-next"} type="button" onClick={this.resetPassword}>Reset Password</button>

                </div>
            </form>
        );
    }

}